import { Drawer } from 'almanac-ui/Drawer/Drawer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from '../Panels.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SEOAnalysis as SEOAnalysisIcon } from 'blaze-ui/icons/36'
import { PlagiarismCheck as BlazePlagiarismCheckIcon } from 'blaze-ui/icons/36'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRight } from 'blaze-ui/icons'
import { PlagiarismDetection } from './PlagiarismDetection'

export const PlagiarismDetectionPanel = observer(() => {
  const rightRailPanelStore = useRootStore().rightRailPanelStore

  const articleId = useRootStore().docStore?.articleId
  return (
    <>
      <Drawer.Header>
        <div className={Styles.header}>
          <div className={Styles.headerInner}>
            <BlazePlagiarismCheckIcon size={20} />
            <Heading level={4} lineClamp={1}>
              Plagiarism Check
            </Heading>
          </div>
          <Drawer.CloseButton />
        </div>
      </Drawer.Header>
      <Drawer.Body>
        <PlagiarismDetection key={articleId}>
          <div className={cx(Styles.nextStepButton, Styles.fixed)} onClick={() => rightRailPanelStore.show('seo')}>
            <SEOAnalysisIcon />
            <div className={Styles.nextAction}>
              <Text variant="label">Next step</Text>
              <Heading level={5}>View SEO Analysis</Heading>
            </div>
            <div className={Styles.arrowRight}>
              <ArrowRight />
            </div>
          </div>
        </PlagiarismDetection>
      </Drawer.Body>
    </>
  )
})
